import { Link } from "react-router-dom";
import { X, Scale, Trash2 } from "lucide-react";
import { useCompare } from "../context/CompareContext";

export default function CompareTray() {
  const { items, remove, clear, max } = useCompare();
  if (items.length === 0) return null;

  return (
    <div data-testid="compare-tray" className="fixed left-1/2 -translate-x-1/2 bottom-24 lg:bottom-6 z-40 w-[min(680px,calc(100vw-16px))]">
      <div className="bg-white/95 backdrop-blur rounded-2xl border border-slate-200 shadow-[0_12px_40px_rgba(15,23,42,0.12)] px-3 py-3 flex items-center gap-3">
        <div className="flex items-center gap-2 flex-1 min-w-0 overflow-x-auto no-scrollbar">
          {items.map((it) => (
            <div key={it.id} className="relative flex-shrink-0 w-16 h-12 rounded-lg overflow-hidden bg-slate-100 border border-slate-200">
              {it.images?.[0] && <img src={it.images[0]} alt="" className="w-full h-full object-cover" />}
              <button
                onClick={() => remove(it.id)}
                aria-label="Remove from compare"
                data-testid={`compare-remove-${it.id}`}
                className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-cm-accent text-white flex items-center justify-center shadow-md"
              >
                <X className="w-3 h-3" />
              </button>
            </div>
          ))}
          {Array.from({ length: Math.max(0, max - items.length) }).map((_, i) => (
            <div key={`empty-${i}`} className="flex-shrink-0 w-16 h-12 rounded-lg border-2 border-dashed border-slate-200" />
          ))}
        </div>
        <button
          onClick={clear}
          data-testid="compare-clear"
          aria-label="Clear compare list"
          className="w-10 h-10 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-600 flex items-center justify-center"
        >
          <Trash2 className="w-4 h-4" />
        </button>
        <Link
          to="/compare"
          data-testid="compare-open"
          className={`px-4 h-10 rounded-xl font-semibold text-sm flex items-center gap-2 press-scale ${items.length < 2 ? 'bg-slate-200 text-slate-400 pointer-events-none' : 'bg-cm-primary hover:bg-cm-accent text-white shadow-md'}`}
        >
          <Scale className="w-4 h-4" />
          Compare {items.length > 1 ? `(${items.length})` : ""}
        </Link>
      </div>
    </div>
  );
}
